<template>
  <v-dialog v-model="isOpen" persistent max-width="500">
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @submit.prevent="onSave"
    >
      <v-layout row wrap>
        <v-card>
          <v-card-title primary-title class="title blue darken-2">
            <span class="white--text">New Customer</span>
          </v-card-title>

          <v-layout row wrap class="pa-3">
            <v-flex sm12 v-if="responseError">
              <span class="red--text">* {{ responseError }}</span>
            </v-flex>

            <div style="bsale:1px solid black;width:300px; text-align:left">
              <p
                style="font-size:15px;margin:1px"
              >Code : {{oldCustomerCode}}</p>
            </div>

            <v-flex sm12 v-if="isAutoCodeSerialization != 'ACTIVE'">
              <v-text-field
                name="code"
                label="Code"
                v-model="customer.code"
                type="text"
                :rules="rules.codeRules"
              ></v-text-field>
            </v-flex>

            <v-flex sm12>
              <v-text-field
                name="name"
                label="Name"
                v-model="customer.name"
                type="text"
                :rules="rules.nameRules"
              ></v-text-field>
            </v-flex>

            <v-flex sm12>
              <v-text-field
                name="phoneNo"
                label="PhoneNo"
                v-model="customer.phoneNo"
                type="text"
                :rules="rules.phoneNoRules"
              ></v-text-field>
            </v-flex>

            <v-flex sm12>
              <v-text-field
                name="email"
                label="Email"
                v-model="customer.email"
                type="text"
              ></v-text-field>
            </v-flex>

            <v-flex sm12>
              <v-select
                :items="creditLevelList"
                v-model="customer.creditLevelId"
                label="Choose Credit Level"
                item-text="name"
                item-value="id"
                menu-props="auto"
                :rules="rules.creditLevelRules"
              ></v-select>
            </v-flex>

            <v-flex sm12>
              <v-autocomplete
                v-model="customer.cityId"
                :items="cityList"
                color="blue-grey lighten-2"
                label="Choose City..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                :rules="rules.cityIdRules"
                @change="getTownshipByCityId(customer.cityId)"
              ></v-autocomplete>
            </v-flex>

            <v-flex sm12>
              <v-autocomplete
                v-model="customer.townshipId"
                :items="townshipList"
                color="blue-grey lighten-2"
                label="Choose Township..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                :rules="rules.townshipIdRules"
              ></v-autocomplete>
            </v-flex>

            <v-flex sm12>
              <v-textarea
                name="address"
                label="Address"
                v-model="customer.address"
                type="text"
                :rules="rules.addressRules"
              ></v-textarea>
            </v-flex>

            <v-flex sm12>
              <v-select
                :items="regionList"
                label="Choose Region ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="name"
                item-value="id"
                menu-props="auto"
                @change="changeRegion"
                v-model="customer.regionId"
              ></v-select>
            </v-flex>

            <v-flex sm12>
              <v-select
                :items="priceModelList"
                label="Choose Price Model ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="name"
                item-value="id"
                menu-props="auto"
                v-model="customer.priceModelId"
              ></v-select>
            </v-flex>

            <v-flex sm6>
              <v-text-field
                label="Account Code"
                v-model="customer.accountCode"
                @click="showAccounts()"
                :rules="rules.codeRules"
                :readonly="true"
              ></v-text-field>
            </v-flex>

            <v-flex sm6>
              <v-text-field
                label="Account Name"
                v-model="customer.accountName"
                :readonly="true"
              ></v-text-field>
            </v-flex>

            <v-layout>
              <v-flex>
                <v-flex sm12>
                  <v-btn
                    color="success"
                    @click="addMargin()"
                    :disabled="addBtnDisabled"
                  >
                    Add Margin
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-flex>
                <v-layout row wrap class="light--text">
                  <v-flex xs3>Level</v-flex>
                  <v-flex xs5>Name</v-flex>
                  <v-flex xs3>Percentage</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(margin, index) in customer.marginList"
                  :key="index"
                >
                  <v-flex xs3>
                    <v-text-field
                      v-model="margin.level"
                      :loading="showAutocompleteLoading"
                      label="Level"
                      :rules="rules.levelRules"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                    <v-text-field
                      v-model="margin.name"
                      :loading="showAutocompleteLoading"
                      label="Name"
                      :rules="rules.nameRules"
                      class="ml-1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      v-model="margin.percentage"
                      type="number"
                      min="0"
                      max="100"
                      oninput="this.value = Math.abs(this.value)"
                      :loading="showAutocompleteLoading"
                      :rules="rules.percentageRules"
                      label="Percentage"
                      class="ml-1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      icon
                      @click="removeMargin(index, margin.id)"
                      :disabled="customer.marginList.length != index + 1"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-flex sm12>
              <div class="text-xs-center">
                <v-btn color="error" @click="dialogClose({})">
                  Cancel
                  <v-icon right>clear</v-icon>
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="saveLoading"
                  :disabled="!valid"
                  type="submit"
                >
                  Save
                  <v-icon right>save</v-icon>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-layout>
    </v-form>

    <account-list-dialog
      :showDialog="accountListDialog"
      :params="{ isParent: false }"
      @close="closeAccountDialog"
    ></account-list-dialog>
  </v-dialog>
</template>
<script>
import { CustomerFormRules } from "../../helpers/validation-rules";
import { customerService } from "../../services/customer-service";
import { creditLevelService } from "../../services/credit-level-service";
import { cityService } from "../../services/city-service";
import { Customer, Margin } from "../../models/model";
import { regionService } from "../../services/region-service";
import { priceModelService } from "../../services/price-model-service";
import AccountListDialog from "../dialogs/AccountListDialog.vue";

export default {
  name: "CustomerDetail",

  components: { AccountListDialog },

  props: {
    showDialog: Boolean,
  },

  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    isAutoCodeSerialization: JSON.parse(
      localStorage.getItem("AUTO_CODE_SERIALIZATION")
    ),
    valid: true,
    responseError: "",
    saveLoading: false,

    customer: new Customer(),
    margin: new Margin(),
    rules: new CustomerFormRules(),

    showAutocompleteLoading: false,
    addBtnDisabled: false,
    cancelBtnDisabled: false,
    statusFlag: true,

    creditLevelList: [],
    regionList: [],
    priceModelList: [],
    cityList: [],
    townshipList: [],
    priceModelParams: {
      regionId: "",
      isExistRegion: false,
    },
    accountListDialog: false,
    oldCustomerCode: "",
    customerList: [],
  }),

  computed: {
    isOpen: {
      get() {
        return this.showDialog;
      },
      set() {
        this.dialogClose({});
      },
    },
  },

  created() {
    this.getCreditLevels();
    this.addMargin();
    this.getAllCity();
    this.getRegionList();
    this.getPriceModelList();
  },

  watch: {
    isOpen: {
      handler() {
        if(this.isOpen) {
          this.getLastCustomer();
        }
      },
    },
  },

  methods: {
    dialogClose(customer) {
      this.customer = new Customer();
      this.$refs.form.resetValidation();
      this.responseError = "";

      this.$emit("close", customer);
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.customer.saleTeamId = this.user.saleTeamId;
        this.customer.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        if (this.customer.code == "") {
          this.customer.code = null;
        }

        customerService
          .saveCustomer(this.customer)
          .then((res) => {
            this.saveLoading = false;
            this.dialogClose(res.data.customer);
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },

    getLastCustomer() {
      customerService
      .getLastCustomer()
      .then((res) => {
        this.oldCustomerCode = res.data.code;
      })
      .catch((err) => {
        console.log(err);
      });
    },

    getCreditLevels() {
      creditLevelService
        .getCreditLevels()
        .then((res) => {
          if (res.data) {
            this.creditLevelList = res.data.creditLevelList;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getAllCity() {
      cityService.getAllCity().then((res) => {
        this.cityList = res.data.cityList;
      });
    },

    getRegionList() {
      regionService
        .getRegionsByStatus("ACTIVE")
        .then((res) => {
          this.regionList = res.data;
          let noregion = {
            id: "",
            name: "----No Region----",
          };
          this.regionList.splice(0, 0, JSON.parse(JSON.stringify(noregion)));
        })
        .catch((err) => {
          console.log(err);
        });
    },

    changeRegion() {
      this.priceModelParams.regionId = this.customer.regionId;
      if (this.customer.regionId) {
        this.priceModelParams.isExistRegion = true;
      } else {
        this.priceModelParams.isExistRegion = false;
      }
      this.getPriceModelList();
    },

    getPriceModelList() {
      priceModelService
        .getAllPriceModelList(this.priceModelParams)
        .then((res) => {
          this.priceModelList = res.data.data;
          let nopricemodel = {
            id: "",
            name: "----No Price Model----",
          };
          this.priceModelList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(nopricemodel))
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getTownshipByCityId(cityId) {
      this.townshipList = [];
      cityService
        .getCityDetail(cityId)
        .then((res) => {
          this.townshipList = res.data.townships;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    addMargin() {
      // deep copy
      margin = new Margin();
      if (this.customer.marginList.length == 0) {
        this.margin.level = 1;
      } else {
        this.margin.level = this.customer.marginList.length + 1;
      }
      let margin = JSON.parse(JSON.stringify(this.margin));
      this.customer.marginList.push(margin);
      if (this.customer.marginList.length == 3) this.addBtnDisabled = true;
    },

    removeMargin(index, marginId) {
      if (marginId) {
        // add delete stock in id
        if (!this.customer.deleteMarginIds) {
          this.customer.deleteMarginIds = [];
        }
        this.customer.deleteMarginIds.push(marginId);
      }
      this.$delete(this.customer.marginList, index);
      if (this.customer.marginList.length != 3) {
        this.addBtnDisabled = false;
      }
      if (this.customer.marginList.length == index) {
        this.cancelBtnDisabled = false;
      }
    },
    showAccounts() {
      this.accountListDialog = !this.accountListDialog;
    },
    closeAccountDialog(account) {
      this.accountListDialog = !this.accountListDialog;
      if (account.id) {
        this.customer.accountId = account.id;
        this.customer.accountCode = account.code;
        this.customer.accountName = account.name;
      }
    },
  },
};
</script>